import {
  Modal as AntModal,
  Button as AntButton,
} from 'antd';
import styled from 'styled-components';
import {
  BonusModalAcceptBtnBg,
  BonusModalRejectBtnBg
} from '@assets'

export const Modal = styled(AntModal)`
  padding: 0px !important;

  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    background-image: url(${(prop) => prop.bg}) !important;
    background-size: contain !important;
		background-repeat: no-repeat !important;
		background-position: center !important;
    background-color: green;
    width: 329px;
    height: 320px;
    margin: 0 auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }

  @media screen and (max-width: 380px) {
    .ant-modal-content{
      width: 300px;
      height: 290px;
    }
  }

  @media screen and (max-width: 320px) {
    .ant-modal-content{
      width: 260px;
      height: 250px;
    }
  }
`

export const Container = styled.div`
  position: absolute;
  top: 50px;
  left: 8%;
  margin: 18px 0;
  width: 85%;
  height: 250px;

  @media screen and (max-width: 380px) {
    top: 50px;
    height: 225px;
  }
  @media screen and (max-width: 320px) {
    top: 40px;
    height: 195px;
  }
`

export const LabelContainer = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainText = styled.div`

  width: 90%;
  margin-top: 10px;

  color: #000;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  white-space: pre-line;

  @media screen and (max-width: 380px) {
    font-size: 10px;
    margin-top: 5px;
  }

  @media screen and (max-width: 320px) {
    font-size: 9px;
  }
`

export const Bottom = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  left: 0%;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;
`;


export const Description = styled.div`
  margin: 0px auto 0;

  color: #0E1017;
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; 

  @media screen and (max-width: 380px) {
    font-size: 8px;
  }
`

export const ButtonWrapper = styled.div`

  margin: 10px 0 5px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 15px;
  padding: 0 4px;
  
  svg{
    cursor: pointer;
  }

  @media screen and (max-width: 380px) {
    gap: 10px;
    padding: 0;
  }

`

const BasicButton = styled(AntButton)`
  font-size: 12px;
  width: 100%;
  height: 46px;

  @media screen and (max-width: 420px) {
    font-size: 10px;
    height: 46px;
  }

  @media screen and (max-width: 320px) {
    height: 40px;
  }

`

export const AcceptButtonWrapper = styled.div`
  width: 50%;
`

export const AcceptButton = styled(BasicButton)`
  background-image: url(${BonusModalAcceptBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  color: #000000 !important;
  line-height: normal;
  

  :hover{
    background-color: transparent !important;
    color: #000000 !important;
  }
`

export const RejectButtonWrapper = styled.div`
  width: 50%;
`

export const RejectButton = styled(BasicButton)`
  background-image: url(${BonusModalRejectBtnBg}) !important;
  background-color: transparent !important;
  background-size: cover;
  background-repeat: no-repeat;

  color: #FFF !important;

  :hover{
    background-image: url(${BonusModalRejectBtnBg}) !important;
    background-color: transparent !important;
    color: #FFF !important;
  }
`